import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  connect() {
    this.openActivityFormMaybe = this.openActivityFormMaybe.bind(this)
    App.Helpers.listenToCustomEvent(document, "checklists:items-update", this.openActivityFormMaybe);
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "checklists:items-update", this.openActivityFormMaybe)
  }

  openActivityFormMaybe(event) {
    const { targetListID, newItem } = event.detail;
    if (newItem && targetListID == this.itemID) {
      this.openActivityForm();
    }
  }

  openActivityForm() {
    App.Helpers.ajaxRequest({ url: this.newActivityURL, successHandler: this.emitActivityFormFetchSuccess.bind(this) });
  }

  emitActivityFormFetchSuccess(response) {
    document.dispatchEvent(createCustomEvent("sortable-checklist-new-item-form-fetch:success", this.element, { html: response, listID: this.itemID }));
  }

  //
  // GETTERS AND SETTERS
  //

  get itemID() {
    return this.data.get("checklist-id");
  }

  get newActivityURL() {
    return this.data.get("new-activity-url");
  }
};



// WEBPACK FOOTER //
// ./app/components/checklists/assets/javascript/checklists-add-button-controller.js